import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { getStrength } from './passwordStrengthHelper'

const strengthColors = [
  '',
  'rgb(152, 18, 43)',
  'rgb(152, 18, 43)',
  'rgb(152, 18, 43)',
  'rgb(80, 130, 90)'
]

const PasswordSecurity = ({
  password = '',
  setStrength
}: {
  password: string
  setStrength?: (strength: number) => void
}) => {
  const { formatMessage } = useIntl()
  const [passwordStrength, setPasswordStrength] = useState<number>(0)

  useEffect(() => {
    const strength = getStrength(password)
    setStrength && setStrength(strength)
    setPasswordStrength(strength)
  }, [password])

  return (
    <div className='password-security-wrapper'>
      <p className='password-security-label'>
        {formatMessage({
          defaultMessage: 'Security',
          id: 'msp.global.security'
        })}
      </p>
      <div className='password-security-bar-wrapper'>
        <div className='password-security-bar'>
          <div
            className='password-security-bar-progress'
            style={{
              width: `${passwordStrength * 25}%`,
              backgroundColor: strengthColors[passwordStrength]
            }}
          />
        </div>
        <p className='password-security-text'>
          {formatMessage({
            defaultMessage:
              'At least 8 characters long, upper-case and lower-case letters (a-z, A-Z), at least one number and at least one special character (e.g. +, $, !, ?, #).',
            id: 'msp.global.security.tips'
          })}
        </p>
      </div>
    </div>
  )
}

export default PasswordSecurity
